var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumbs',{attrs:{"title":"Queue Report"}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card p-4"},[_c('div',[_c('dataTableVue',{ref:"refDataTable",attrs:{"isExport":true,"isFilter":true,"renderMode":'csr',"data":{
                    columns: _vm.columns,
                    rows: _vm.rows,
                    exportDetail: _vm.exportDetail,
                    filter_custom: 'filterQueueReport',
                    rowCustom: 'rowQueueReport',
                    module: 'ccp'
                }},on:{"load":_vm.loadItems}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }